module.exports = function(hljs) {
    return {
        disableAutodetect: true
    };
};


//////////////////
// WEBPACK FOOTER
// ../~/highlight.js/lib/languages/plaintext.js
// module id = 1024
// module chunks = 0